import Language from '../helpers/Language';
import { Maintenance, MultiLingualStylesheet, Stylesheet } from '../interfaces/Stylesheet';

export const getMaintenance = (stylesheet: MultiLingualStylesheet | Stylesheet): Maintenance => {
  return 'maintenance' in stylesheet ? stylesheet.maintenance : stylesheet[Language.getLanguage()].maintenance;
};

export const isInMaintenanceMode = (stylesheet: MultiLingualStylesheet | Stylesheet): boolean => {
  const maintenance = getMaintenance(stylesheet);

  let inTimeframe: boolean;

  if (maintenance.startTime && maintenance.endTime) {
    const startTime = new Date(maintenance.startTime);
    const endTime = new Date(maintenance.endTime);
    const now = new Date();

    inTimeframe = (now > startTime && now < endTime);
  } else {
    // If not both start and end time is set, we only care about the status.
    inTimeframe = true;
  }

  return maintenance.status && inTimeframe;
};
